import EitherOrBasicModel from "./EitherOrBasicModel";

export default class EitherOrFullModel extends EitherOrBasicModel {
  public rules: string = "";
}
